import { Card, Chip } from '@heroui/react';

export type StatStatus = 'default' | 'accent' | 'success' | 'warning' | 'danger';

interface StatCardProps {
  label: string;
  value: string;
  status?: StatStatus;
}

export function StatCard({ label, value, status }: StatCardProps) {
  return (
    <Card className="bg-surface">
      <div className="p-4">
        <p className="text-sm text-muted">{label}</p>
        <div className="flex items-center justify-between mt-1">
          <p className="text-2xl font-bold text-foreground">{value}</p>
          {status && (
            <Chip size="sm" color={status} variant="soft">
              {status === 'success' ? '↑' : status === 'danger' ? '↓' : '•'}
            </Chip>
          )}
        </div>
      </div>
    </Card>
  );
}
